module.exports = __webpack_public_path__ + "static/media/external-link-white.eeca9cd4.svg";